// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"44849e59","254":"a48deff6","316":"6186245b","333":"04e83236","601":"b1778309","894":"4b467416"}[chunkId] + ".chunk.css";
};